import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, LoadingIndicator, LOADING_MESSAGE, Typography} from '@fupa/fupa-uikit';
import MatchHighlights from 'app/components/match/MatchHighlights';
import {AppBarDesktopWrapper} from 'app/components/appBar/AppBarDesktopStyle';
import {useClickTracking} from 'app/hooks/useClickTracking';
import {numberWithThousandSeparator} from 'app/helpers/helpers';
import {Collapse, IconButton} from '@mui/material';
import {ExpandLess, ExpandMore} from '@mui/icons-material';

const MatchHeaderContent = styled.div`
  background-color: ${COLORS.white};
  width: inherit;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  max-width: ${props => props.theme.mobileContentWidth}px;
  margin: auto;
  ${props => props.theme.desktopLayout`
    margin-left: 0;
    max-width: ${props => props.theme.desktopContentWidth}px;
   `}
`;

const SideInformation = styled.div`
  width: 100%;
  padding: ${SIZES['16']} ${SIZES['16']} ${SIZES['8']} 0;
  text-align: right;
  height: ${SIZES[44]};
`;

const STATIC_HEADER_HEIGHT = 140;

const MatchHeaderDynamic = ({highlights, matchInfo, isFetching, onExpansionChange}) => {
  let displayHighlights;
  const [show, setShow] = useState(matchInfo?.section === 'POST');
  if (isFetching) {
    displayHighlights = <LoadingIndicator message={LOADING_MESSAGE.loadingHighlights} bgColor />;
  }
  if (highlights && matchInfo && matchInfo.homeTeam) {
    displayHighlights = <MatchHighlights highlights={highlights} homeTeamSlug={matchInfo.homeTeam.slug} />;
  }
  const ref = useRef(null);

  const {clicks} = useClickTracking('match', matchInfo);
  const handleChange = () => {
    setShow(prev => !prev);
  };

  const checkHighlightsCollapse = () => {
    if (show) {
      if (document.documentElement.scrollTop > ref.current.clientHeight / 2 + STATIC_HEADER_HEIGHT) {
        setShow(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', checkHighlightsCollapse);

    return () => document.removeEventListener('scroll', checkHighlightsCollapse);
  }, []);

  useEffect(() => {
    onExpansionChange(show);
  }, [show]);

  return (
    <>
      {show ? (
        <IconButton style={{display: 'flex', margin: 'auto'}} onClick={handleChange}>
          <ExpandLess />
        </IconButton>
      ) : (
        <IconButton style={{display: 'flex', margin: 'auto'}} onClick={handleChange}>
          <ExpandMore />
        </IconButton>
      )}
      <Collapse timeout={750} in={show}>
        <AppBarDesktopWrapper ref={ref}>
          <MatchHeaderContent>
            {displayHighlights}
            <SideInformation>
              <Typography variant='caption1'>{numberWithThousandSeparator(clicks)} Aufrufe</Typography>
            </SideInformation>
          </MatchHeaderContent>
        </AppBarDesktopWrapper>
      </Collapse>
    </>
  );
};

export default MatchHeaderDynamic;
